import React from "react";
import { FaUserPlus, FaBoxOpen, FaCalendarAlt, FaBell, FaWrench, FaChartBar } from "react-icons/fa";
import DashboardImg3 from '../../assets/DashboardImage3.png';
import DashboardImg4 from '../../assets/DashboardImage4.png';

import LogisticsImg from '../../assets/Logistics.png';
import WhyassetflowImg from '../../assets/Whyassetflow.png'
import RetailImg from '../../assets/Retail.png';
const steps = [
  {
    icon: <FaUserPlus />,
    num: "01",
    title: "Sign Up & Configure Roles",
    desc: "Create accounts for operators, technicians, and managers. Each gets a tailored portal with appropriate permissions and dashboards.",
    image: RetailImg
  },
  {
    icon: <FaBoxOpen />,
    num: "02",
    title: "Register Your Assets",
    desc: "Add equipment with details — name, serial number, category, location, purchase info, warranty dates, and supporting documents.",
    image: RetailImg
  },
  {
    icon: <FaCalendarAlt />,
    num: "03",
    title: "Set Maintenance Schedules",
    desc: "Choose maintenance frequency (weekly, monthly, quarterly, yearly, or custom) and a start date. The system auto-tracks every cycle.",
    image: LogisticsImg
  },
  {
    icon: <FaBell />,
    num: "04",
    title: "Receive Smart Alerts",
    desc: "Get notified when maintenance is due, warranties are expiring, or stock is running low — all on your personalized dashboard.",
    image: WhyassetflowImg
  },
  {
    icon: <FaWrench />,
    num: "05",
    title: "Assign & Track Work Orders",
    desc: "Create maintenance requests, assign technicians by skill, set priority levels, and track progress in real time until completion.",
    image: DashboardImg3
  
  },
  {
    icon: <FaChartBar />,
    num: "06",
    title: "Analyze & Optimize",
    desc: "Use interactive dashboards to spot trends, plan budgets, and optimize operations with data-driven insights and KPI tracking.",
    image: DashboardImg4
  }
];

const SystemWorkingSection = () => {
  return (
    <section id="how-it-works" className="lp-working">
      <div className="lp-working__inner">
        <div className="lp-section-header">
          <span className="lp-section-tag">How It Works</span>
          <h2>Get Started in 6 Simple Steps</h2>
          <p>
            From sign-up to full asset management — the entire process is
            designed to be simple and quick for any team.
          </p>
        </div>

        <div className="lp-working__timeline">
          {steps.map((s, i) => (
            <div className="lp-working__step" key={i}>
              <div className="lp-working__step-number">{s.num}</div>
              <div className="lp-working__step-image">
                <img src={s.image} alt={s.title} />
              </div>
              <div className="lp-working__step-content">
                <div className="lp-working__step-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemWorkingSection;
